import scanImport from './scanImport';
import excelImport from './excelImport';
import imageImport from './imageImport';
import manualImport from './manualImport';
import ocrImport from './ocrImport';
import invoiceFetch from './invoiceFetch';
import queryocr from './queryocrStatus';
export default {
    scanImport,
    excelImport,
    imageImport,
    manualImport,
    ocrImport,
    invoiceFetch,
    queryocr
};


// WEBPACK FOOTER //
// ./src/api/invoiceImport/index.ts